export enum CardType {
  tokyuCard = '01',
  tokyuPointCardRed = '02',
  tokyuPointCardGreen = '03',
}
